import { useEffect, useRef, useState } from 'react'
import './web-test-why.css'

const BENEFITS = [
  {
    title: 'Defined Before You Trade',
    body: 'Know the predefined target, stop and illustrative outcome before execution.',
  },
  {
    title: 'You Choose the Direction',
    body: 'The trader—not Perfect Predict—selects BUY or SELL.',
  },
  {
    title: 'Focused Markets',
    body: 'Structured prediction trading is currently available on Gold and Silver.',
  },
  {
    title: 'MT5 Execution',
    body: 'Trades are executed through MetaTrader 5 infrastructure.',
  },
] as const

export function WebTestWhy() {
  const rootRef = useRef<HTMLElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = rootRef.current
    if (!el) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setVisible(true)
          io.disconnect()
        }
      },
      { threshold: 0.12 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <section
      ref={rootRef}
      id="why-perfect-predict"
      className={`ww-section${visible ? ' is-visible' : ''}`}
      aria-labelledby="ww-title"
    >
      <div className="ww-inner ww-layout">
        <header className="ww-intro">
          <p className="ww-eyebrow">Benefits</p>
          <h2 id="ww-title" className="ww-title">
            Why Perfect Predict
          </h2>
          <p className="ww-subtitle">
            Structure first: predefined parameters, trader-selected direction, and MT5 execution.
          </p>
        </header>

        <div className="ww-grid ww-grid--benefits">
          {BENEFITS.map((item, index) => (
            <article
              key={item.title}
              className="ww-card"
              style={{ ['--ww-i' as string]: index }}
            >
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
